import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../../utils/Encryption";
import { useLazyGetPDFQuery } from "../../../app/services/common/commonServiceApi";
import { useGenerateCreditNoteForBookingMutation, useGetBookingListForIndividualMemberByIdMutation } from "../../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi";
import ToastService from "../../../services/toastService/ToastService";
import { saveAs } from "file-saver";
import Buttons from "../../../components/ui/button/Buttons";
import ButtonsNew from "../../../components/ui/button/ButtonsNew";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EventsBookings = () => {
  const params = useParams();
  const memberId = Number(decryptAESID(params.memberId));
  const audit = getAuditContext();
  const [eventBookingList, seteventBookingList] = useState([]);

  const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF }] = useLazyGetPDFQuery();
  const [getBookingListForIndividualMemberById, { isSuccess: getBookingListForIndividualMemberByIdIsSuccess, isLoading: getBookingListForIndividualMemberByIdIsLoading, data: getBookingListForIndividualMemberByIdResponse, },] = useGetBookingListForIndividualMemberByIdMutation();
  const [generateCreditNote, { isLoading: isLoading, isSuccess: isSuccess, data: responseCreditNote }] = useGenerateCreditNoteForBookingMutation()

  useEffect(() => {
    if (memberId > 0) {
      let request = {
        MemberId: memberId,
        isCorporate: false,
      };
      getBookingListForIndividualMemberById(request);
    }
  }, [memberId]);

  useEffect(() => {
    if (!isLoading && isSuccess && responseCreditNote) {
      ToastService.success("Credit Note Generated Successfully");
    }
  }, [isLoading, isSuccess, responseCreditNote]);

  useEffect(() => {
    if (!getBookingListForIndividualMemberByIdIsLoading && getBookingListForIndividualMemberByIdIsSuccess && getBookingListForIndividualMemberByIdResponse) {
      if (getBookingListForIndividualMemberByIdResponse.length > 0) {
        console.log("getBookingListForIndividualMemberByIdResponse", getBookingListForIndividualMemberByIdResponse);
        debugger;
        let resData = getBookingListForIndividualMemberByIdResponse;
        const newArr = [];

        resData.map((x) => {
          const copy = { ...x }; // make a shallow clone
          if (copy.isGuest !== true) {
            copy.guestList = [];
          }
          newArr.push(copy);
        });
        newArr.map((x) => {
          return resData.filter(
            (guest) =>
              guest?.bookingAttendeeInformationId !==
              x.bookingAttendeeInformationId &&
              guest?.bookingId === x.bookingId &&
              guest?.isGuest === true
          );
        });

        seteventBookingList(newArr);
      } else {
        seteventBookingList();
      }
    }
  }, [getBookingListForIndividualMemberByIdIsLoading, getBookingListForIndividualMemberByIdIsSuccess, getBookingListForIndividualMemberByIdResponse,]);

  const onInvoiceReceiptFileDownload = async (flag, name, field) => {
    const fileName = name.split("\\").pop();
    let request = {
      type: flag,
      fileName: name,
    };
    const response = await getPDF(request);

    if (response?.data) {
      if (field === "invoice") {
        saveAs(response?.data?.fileData, fileName);
      } else if (field === "receipt") {
        saveAs(response?.data?.fileData, fileName);
      }
      else if (field === "creditNote") {
        saveAs(response?.data?.fileData, fileName);
      }
    } else {
      ToastService.error("Something Went Wrong");
    }
  };
  const handleCancelBooking = (memberId, eventId, eventTimeSlotId, bookingId, creditNoteFilePath) => {
    // Implement the logic to cancel the booking
    debugger
    console.log("Cancel Booking for ID:", bookingId);
    // You can call an API or perform any other action here

    let request = {
      IPASMemberId: memberId || null,
      EventId: eventId || null,
      BookingId: bookingId || null,
      EventTimeSlotId: eventTimeSlotId || null,
      RefundAmount: 0,
      CreditNoteFilePath: null,
      CreatedBy: audit.adminUserId,
      CreatedAppId: audit.appId,
    };
    generateCreditNote(request);
  };

  const [isOpen, setIsOpen] = useState(false);


  const toggleDetails = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <>
      {eventBookingList?.map((item, key) => {
        return (
          <>
            <div className="financial-record event-booking-container">
              <div
                className="row col-lg-12 position-relative financial-record-separator"
                key={key}
              >
                <div
                  className={`${item?.bookingStatus === "Booked"
                    ? "paid-lable"
                    : "pending-lable"
                    }`}
                >
                  <span className="fs-6">
                    {item?.bookingStatus}
                  </span>
                </div>
                <div>
                  <div className="top-section">
                    {item?.lessonList && item?.lessonList.length > 0 && (
                      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 d-flex justify-content-between">
                        <div className="session-details">
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={toggleDetails}
                          >
                            {isOpen ? "-" : "+"} View session details
                          </label>
                          {item?.lessonList.map((les, lesIndex) => {
                            return (
                              <div className="mr-5">
                                <div>
                                  {isOpen && (
                                    <span
                                      style={{
                                        display: "block",
                                        marginTop: "5px",
                                      }}
                                    >
                                      {new Date(
                                        les.eventLessonDate
                                      ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}{" "}
                                      {les.eventStartTime} - {les.eventEndTime}
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <div className="main-title">
                      <label>Event Name :</label>
                      <span> {item?.eventName}</span>
                    </div>
                  </div>{" "}
                </div>
                <div className="row col-lg-10 col-xl-10 col-md-10 col-sm-12 col-12">
                  <div className="row col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12  financial-record-group">
                    <div className="bold">
                      <label>Company Name :</label>
                      <span> {item?.companyName}</span>
                    </div>
                    <div>
                      <label>Booking Status :</label>
                      <span> {item?.bookingStatus}</span>
                    </div>
                    <div>
                      <label>Booking Date :</label>
                      {/* <span> {new Date(item.paymentDate).toLocaleDateString('en-GB')}</span> */}
                      <span>
                        {" "}
                        {new Date(item?.bookingDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </span>
                    </div>
                    <div>
                      <label> Booking Ref:</label>
                      <span> {item?.bookingReferenceNo}</span>
                    </div>
                    <div>
                      <label>Attendee Name:</label>
                      <span>
                        {" "}
                        {item?.firstName} {item?.lastName}
                      </span>
                    </div>
                    <div>
                      <label>Type:</label>
                      <span>{item?.eventTypeName}</span>
                    </div>
                    <div>
                      <label>Payment Method:</label>
                      <span>{item?.paymentVia}</span>
                    </div>
                  </div>
                  <div className="row col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12   financial-record-group">

                    <div>
                      <label> Base Price:</label>
                      <span>
                        S$
                        {parseFloat(
                          item?.subTotalPrice - item?.addOnPrice
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                    <div>
                      <label>Add On Price:</label>
                      <span>
                        S$
                        {parseFloat(item?.addOnPrice).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                    {item?.addOnList?.length > 0 && (
                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-12 d-flex justify-content-between">
                        {item.addOnList.map((addon, addonIndex) => {
                          return (
                            <div className="mr-5">
                              <div>
                                <label>Event AddonTyoe:</label>
                                <span> {addon.eventAddOnType}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-2 col-xl-2 col-md-2 col-sm-12 col-12">
                  <div className="text-end record-btn ">
                    {item?.invoicePath && (
                      <Buttons
                        buttonText="View Invoice"
                        // buttonTypeClassName="outline-theme-btn btn mb-3 "
                        buttonTypeClassName={`outline-theme-btn btn mb-3`}
                        disabled={!item?.invoicePath}
                        onClick={() =>
                          onInvoiceReceiptFileDownload(
                            "FullFilePath",
                            item?.invoicePath,
                            "invoice"
                          )
                        }
                      />
                    )}
                    {item?.receiptPath && (
                      <Buttons
                        buttonText="View Receipt"
                        buttonTypeClassName={`outline-theme-btn btn  mb-3 `}
                        disabled={!item?.receiptPath}
                        onClick={() =>
                          onInvoiceReceiptFileDownload(
                            "FullFilePath",
                            item?.receiptPath,
                            "receipt")
                        }
                      />
                    )}
                    {item?.bookingStatusId === 2 && (
                      <ButtonsNew
                        buttonText="Cancel Booking"
                        buttonTypeClassName={`theme-btn btn  mb-3`}
                        isLoading={isLoading}
                        onClick={() => { handleCancelBooking(item?.memberId, item?.eventId, item?.eventTimeSlotId, item?.bookingId) }}
                      />
                    )}
                    {item?.creditNotePath && (
                      <ButtonsNew
                        buttonText="Credit Note"
                        buttonTypeClassName={`theme-btn btn  mb-3`}
                        onClick={() => {
                          onInvoiceReceiptFileDownload("FullFilePath", item?.creditNotePath, "creditNote");
                        }}
                      // onClick={() => { handleCancelBooking(item?.memberId, item?.eventId, item?.eventTimeSlotId, item?.bookingId) }}
                      />
                    )}
                    {(item?.guestList || []).length > 0 && (
                      <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 d-flex justify-content-between">
                        {item?.guestList.map((guest, guestIndex) => {
                          return (
                            <div className="mr-5">
                              <div>
                                <label>Guest</label>
                                <span> {guestIndex + 1}</span>
                              </div>

                              <div>
                                <label>Booking Ref:</label>
                                <span>{guest.bookingReferenceNo}</span>
                              </div>
                              <div>
                                <label>First Name:</label>
                                <span>{guest.firstName}</span>
                              </div>
                              <div>
                                <label> Mobile:</label>
                                <span>{guest.contactNo}</span>
                              </div>
                              <div>
                                <label> Company:</label>
                                <span>{guest.companyName}</span>
                              </div>
                              <div>
                                <label> Last Name:</label>
                                <span>{guest.lastName}</span>
                              </div>
                              <div>
                                <label> Email:</label>
                                <span>{guest.email}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default EventsBookings;
